'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EmptyProductsAndSolutions: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.productsAndSolutions')

  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/new-product-illustration.svg"
      variant="base"
    />
  )
}
